import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation ActionReserveMutation($input: Action__ReserveInput!) {
    actionReserve(input: $input) {
        entity { 
          id
          dbId
          availability
          entityStates {
            id
            dbId
            state
            dueDate
            userId
          }
        }
      error
    }
  }
`;

const commit = input =>
  createMutation({
    mutation,

    variables: {
      input
    }
  });

export default { commit };
